// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function isFunction(item: unknown): item is Function {
    return typeof item === "function";
}

function isAsyncFunction(
    func: unknown,
): func is (...args: unknown[]) => Promise<unknown> {
    return (
        isFunction(func) &&
        func.constructor &&
        func.constructor.name === "AsyncFunction"
    );
}

export { isAsyncFunction, isFunction };
